/** @format */

import React, { FC, useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import { Card, Icon, Split, _$ } from '@king-design/react'
import MointorCrumb from 'src/components/MonitorCrumb'
import QuickRangeDate from 'src/components/QuickRangeDate'
import ChartContent from 'src/containers/MonitorCustommonitor/CustommonitorTarget/ChartCtontent'
import TargetTabs from 'src/containers/MonitorCustommonitor/CustommonitorTarget/TargetTabs'
import API from 'src/api/ApiMonitorCustomAlarm'
import { request } from 'src/utils'
import dayjs from 'dayjs'
import useNavRegion from 'src/hooks/useNavRegion'

const CustommonitorTarget: FC<{ className?: string }> = ({ className }) => {
  // params
  const [nameSpace, setNameSpace] = useState([])
  const [metricListObject, setMetricListObject] = useState(null)
  const [metricTotalCount, setMetricTotalCount] = useState<number>(0)
  const [updatePeriod, setUpdatePeriod] = useState([])
  const [queryNameSpace, setQueryNameSpace] = useState<string>('')
  const [queryMetric, setQueryMetric] = useState<string>('')
  const [chartData, setChartData] = useState([])
  const [chartHeight, setChartHeight] = useState<string>('320px')
  const dateTime = useRef({
    startTime: dayjs().subtract(30, 'm').unix(),
    endTime: dayjs().unix()
  })

  // 控制台region
  const region = useNavRegion({
    isUpdate: true,
    filterResult: result => result.filter(item => item.tag === 1)
  })

  // 切换region的时候重新获取命名空间list、重新渲染chart、获取所有指标
  useEffect(() => {
    if (region) {
      getNameSpace()
      getAllMetricList()
      setMetricListObject(() => null)
      const { startTime, endTime } = dateTime.current
      startTime && endTime && getChartData()
    }
  }, [region, queryNameSpace])

  // 获取命名空间List
  const getNameSpace = async () => {
    const result = await request(API.getNameSpace, {
      method: 'GET',
      data: {
        region,
        query: queryNameSpace
      }
    })
    if (result?.data?.nameSpaceList) {
      setNameSpace(result.data.nameSpaceList)
    } else {
      setNameSpace([])
    }
  }

  // 获取所有指标
  const getAllMetricList = async () => {
    const result = await request(API.getDescribeMetrics, {
      data: {
        region,
        page: 1,
        pageSize: 99999,
        nameSpace: '',
        query: ''
      }
    })
    // 将当前region下的metric分到对应的nameSpace下
    const metricListObject = {}
    result.data?.metricList?.forEach(metricItem => {
      if (metricItem.region === region) {
        if (metricListObject[metricItem.nameSpace]) {
          metricListObject[metricItem.nameSpace].push(metricItem)
        } else {
          metricListObject[metricItem.nameSpace] = [metricItem]
        }
      }
    })
    setMetricTotalCount(result.data?.totalCount || 0)
    setMetricListObject(metricListObject)
  }

  // 获取chartData
  const getChartData = async () => {
    const { startTime, endTime } = dateTime.current
    const metricList = JSON.parse(localStorage.getItem('metricList')) || []
    const filterMetric = metricList.filter(item => item.region === region)
    if (filterMetric.length) {
      const params = metricList
        .filter(item => item.region === region) // 过滤region
        .map(item => {
          return {
            ...item,
            startTime: startTime,
            endTime: endTime
          }
        })
      const { data } = await request(API.GetChartData, {
        data: params,
        method: 'POST'
      })
      if (data?.length) {
        // 返回数据排序，保持顺序的一致性
        const sortData = []
        params.forEach(paramItem => {
          const findItem = data?.find(dataItem => {
            return dataItem?.alias === paramItem?.alias
          })
          findItem && sortData.push(findItem)
        })
        // 设置period到列表
        const localMetricList = JSON.parse(localStorage.getItem('metricList'))
        const updateLocalMetricList = localMetricList.map(localItem => {
          const findItem = [].concat(data).find(dataItem => dataItem?.alias === localItem?.alias)
          localItem.period = findItem?.period || 1
          return localItem
        })
        setUpdatePeriod(updateLocalMetricList)
        setChartData(sortData || [])
      } else {
        setChartData([])
      }
    } else {
      setChartData([])
    }
  }
  return (
    <div className={className}>
      <MointorCrumb breadArr={[{ title: _$('自定义监控') }, { title: _$('指标') }]} />
      <Card>
        <div className="range-date">
          <QuickRangeDate
            format="YYYY-MM-DD HH:mm"
            disabledSeconds={true}
            optionalDateRange={30}
            defautlValue={'近0.5小时'}
            quickRange={['近0.5小时', '近1天', '近3天', '近1周']}
            changeValue={date => {
              dateTime.current.startTime = dayjs(date[0]).set('second', 0).unix()
              dateTime.current.endTime = dayjs(date[1]).set('second', 0).unix()
              date[0] && date[1] && getChartData()
            }}
          />
        </div>
        <Split
          mode="vertical"
          min="320"
          firstSize={chartHeight}
          onChangeFirstSize={size => {
            setChartHeight(size)
          }}
          slotFirst={
            <React.Fragment>
              <ChartContent chartData={chartData} />
            </React.Fragment>
          }
          slotDrag={
            <React.Fragment>
              <Icon className="ion-navicon-round" />
            </React.Fragment>
          }
          slotLast={
            <React.Fragment>
              <TargetTabs
                region={region}
                nameSpace={nameSpace}
                metricListObject={metricListObject}
                metricTotalCount={metricTotalCount}
                queryNameSpace={queryNameSpace}
                setQueryNameSpace={setQueryNameSpace}
                queryMetric={queryMetric}
                setQueryMetric={setQueryMetric}
                getChartData={getChartData}
                getNameSpace={getNameSpace}
                getAllMetricList={getAllMetricList}
                updatePeriod={updatePeriod}
              />
            </React.Fragment>
          }
        ></Split>
      </Card>
    </div>
  )
}

export default styled(CustommonitorTarget)`
  .k-card {
    .k-card-body {
      height: 100%;
    }
  }
  .range-date {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .k-tab span {
    color: #0a5eee;
  }
  .k-split {
    margin-top: 16px;
    .k-split-line-wrapper {
      height: 20px;
    }
  }
`
